export default {
    ...window.epAppData,
  };
  